import { render, staticRenderFns } from "./researchNews.vue?vue&type=template&id=4b4fc7f7&scoped=true&"
import script from "./researchNews.vue?vue&type=script&lang=js&"
export * from "./researchNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4fc7f7",
  null
  
)

export default component.exports